import { useMutation, useQueryClient } from '@tanstack/react-query';

import * as Filtrator from '@Stores/Filtrator';
import Configurator from '@Api/Configurator';
import * as PageProductStore from '@Stores/PageProduct';
import useKeys from './useKeys';

import type { FilterResultData } from '@Api/Configurator/getFilterResult';
import type { ConfiguratorData } from '@Pages/PageProduct';

const useResetFilters = () => {
  const entityId = 'configurator-textile';
  const queryClient = useQueryClient();
  const {
    product: { id },
  } = PageProductStore.useData();
  const { filters: filterKeys, configurator: keys } = useKeys();

  const { mutateAsync, isPending } = useMutation({
    mutationKey: filterKeys,
    mutationFn: async () => {
      const res = await Configurator.getFilterResultCount({
        shopProductId: id,
        params: {},
      });
      return res;
    },
    onSuccess: (res) => {
      queryClient.setQueryData<FilterResultData>(filterKeys, (prev) => ({
        ...prev,
        filters: { ...res.fabricFilters },
        count: res.count,
      }));
      queryClient.setQueryData(keys, (prev: ConfiguratorData) => {
        return {
          ...prev,
          tabs: prev.tabs.map((tab) => {
            return {
              ...tab,
              count: tab.id === 'upholstery' ? res.count : tab.count,
            };
          }),
        };
      });
      Filtrator.changeCount(entityId, { ...res.fabricFilters, totalCount: res.count });
    },
  });

  return {
    resetFilters: mutateAsync,
    isPending,
  };
};

export default useResetFilters;
